import styled from 'styled-components';

export const BackToTop = styled.button`
  position: fixed;
  bottom: 15rem;
  right: 1rem;
  z-index: 5;
  transition: bottom 0.5s, background-color 0.3s, color 0.3s;
  background-color: ${({ theme }) => theme.COLORS.primary};
  color: ${({ theme }) => theme.COLORS.textStandard};
  font-size: 3rem;
  border: none;
  outline: none;
  padding: 0.5rem 1rem;
  opacity: 1;
  animation-name: fadeInOpacity;
  animation-iteration-count: 1;
  animation-timing-function: ease-in;
  animation-duration: 0.3s;

  @keyframes fadeInOpacity {
    0% {
      opacity: 0;
    }
  }
  100% {
    opacity: 1;
  }

  &:hover {
    cursor: pointer;
    bottom: 16rem;
  }

  @media (${({ theme }) => theme.MEDIA_MIN.tablet}) {
    right: 3rem;
  }
`;
